import { PUBLIC_LINKS } from "../config/publicLinks.js";
import { LEGAL_LINKS } from "../lib/legalRoutes.js";
import { BrandLockup } from "./landing/BrandLockup.jsx";

export function SiteFooter({ legal = false }) {
  return (
    <footer className={legal ? "site-footer site-footer--legal" : "site-footer"}>
      <div className="site-footer__brand">
        <a href="/" aria-label="Il Consulente AI, torna alla pagina iniziale">
          <BrandLockup compact />
        </a>
        <span>
          © {new Date().getFullYear()} {" "}
          <a href={PUBLIC_LINKS.freeFuture} target="_blank" rel="noreferrer">Free Future LDA</a>
        </span>
      </div>
      <nav className="site-footer__links" aria-label="Percorso, informazioni legali e assistenza">
        {!legal ? <a href="#metodo">Metodo</a> : null}
        {!legal ? <a href="#percorso">Percorso</a> : null}
        {!legal ? <a href="#organizzazioni">Per le organizzazioni</a> : null}
        {LEGAL_LINKS.map((link) => (
          <a href={link.href} key={link.href}>{link.label}</a>
        ))}
        <a href={PUBLIC_LINKS.xaiSchool} target="_blank" rel="noreferrer">XAISchool</a>
        <a href={PUBLIC_LINKS.support} target="_blank" rel="noreferrer">Assistenza</a>
      </nav>
    </footer>
  );
}
